function getHostJSafra() {
  const currentUrl = window.location.href

  if (
    currentUrl.indexOf("-homol.") !== -1 ||
    currentUrl.indexOf("localhost") !== -1 ||
    currentUrl.indexOf("52.45.235.30") !== -1
  ) {
    return "https://scdcap-h.safra.com.br/asp/FINIdentPos_Frame.asp"
  }
  return "https://wwws.jsafra.com.br/asp/FINIdentPos_Frame.asp"
}


const formExtratoTarifas = {
  form: document.querySelector('.js-form-extrato-tarifas'),
  formHidden: document.querySelector('form.formHidden'),
  hostSafra: getHostJSafra(),
  pristine: {},
  init() {
    this.formInitialize()
  },
  formInitialize() {
    
    this.formHidden.action = this.hostSafra

    this.pristine = new Pristine(this.form)

    IMask(this.form.querySelector("#cpf"), {
      mask: "000.000.000-00",
    })

    this.form.addEventListener('submit', event => {
      event.preventDefault()

      let valid = this.pristine.validate()

      if (valid) {

        const cpf = document
          .querySelector("input#cpf")
          .value.replace(/[^0-9]/g, "")

        this.formHidden.querySelector("[name='txtCPF']").value = cpf
        this.formHidden.submit()

      }
    })
  }
}

formExtratoTarifas.init()